import { render, staticRenderFns } from "./AuctionDetailModal.vue?vue&type=template&id=70c5ebd1&scoped=true&"
import script from "./AuctionDetailModal.vue?vue&type=script&lang=ts&"
export * from "./AuctionDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionDetailModal.vue?vue&type=style&index=0&id=70c5ebd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5ebd1",
  null
  
)

export default component.exports